<template>
  <div class="business-information-com">
    <jw-modal :visible="visible" @cancel="correlationClose" class="information-modal" :mask-closable="false" :body-style="{ height: '500px', display: flex, 'flex-direction': column }">
      <template #title>{{ $t('关联客户信息') }} </template>
      <div class="message-title">
        <jw-input-search @blur="getSerachData(customerName)" @clear="getSerachData(customerName)" @keyup.enter="getSerachData(customerName)" @search="getSerachData(customerName)" v-model="customerName" allow-clear>
          <!-- <template #suffix><icon-search /> </template> -->
        </jw-input-search>
        <jw-tooltip :content="$t('tips.myCostomer')" position="rt" mini>
          <icon-question-circle size="20" style="margin-left: 10px; cursor: pointer" />
        </jw-tooltip>
      </div>

      <template v-if="list?.length">
        <div class="list-content">
          <div v-for="item in list" :key="item.id" class="company-name-item">
            <div class="company-content">
              <div>
                <span class="company-name"><icon-bar-chart size="20" style="margin-right: 5px" />{{ item.customerName }}</span>
              </div>
              <jw-button @click="selectCustomer(item)" size="small" type="primary" style="margin-left: 30px">{{ $t('关联') }}</jw-button>
            </div>
            <div class="registeredfund-item">
              <span class="message-with">{{ $t('负责人') }}：<xl-avatar v-if="item.chargePerson" :avatar="{ name: item.chargePersonName || '', url: item.chargePersonAvatar, id: item.customerId }" :size="22" /> <template v-else>-</template></span>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <template v-if="type == '3'">
          <div class="empty-content">
            <jw-empty class="eltimeline" :img-src="imgSvg"> {{ $t('未发现客户') }} </jw-empty> <jw-button size="small" type="primary" @click="createdCustom">创建客户</jw-button>
          </div>
        </template>
        <template v-else>
          <div class="empty-content">
            <jw-empty class="eltimeline" :img-src="imgSvg"> {{ $t('暂无数据') }} </jw-empty>
          </div></template
        >
      </template>
      <template #footer>
        <jw-space>
          <jw-pagination v-if="list?.length" :total="total" :current="page" :page-size="pageSize" show-total @change="next" />
          <jw-button v-else @click="correlationClose">{{ $t('取消') }}</jw-button>
        </jw-space>
      </template>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, toRefs, computed, inject } from 'vue';
import { opportunityService, contractService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import imgSvg from '@/assets/images/img-no-record.svg';
export default {
  name: 'AssociatedCustomer',
  setup(props, ctx) {
    const { t } = useI18n();
    const data = reactive({
      visible: false,
      loading: false,
      list: [],
      pageSize: 10,
      page: 1,
      customerName: '',
      total: 0,
      type: '',
      isNotRelated: null,
      id: inject('detailParams')?.id || inject('defaultParams')?.id //商机id
    });
    const searchObj = reactive({
      //筛选条件
      list: [
        {
          type: 'input',
          label: '',
          placeholder: '请输入客户名称',
          multiple: true,
          name: 'customerName',
          value: computed(() => data.customerName)
        }
      ]
    });
    const getSerachData = (val) => {
      console.log(val);
      data.customerName = val;
      getCustomerQcc();
    };
    //选择客户关联
    const selectCustomer = (item) => {
      const params = {
        id: data.id,
        customerId: item.customerId
      };
      let url;
      if (data.type == '8') {
        //合同
        url = contractService.relateCustomer(params);
      }
      if (data.type == '3') {
        //商机
        url = opportunityService.relateCustomer(params); //商机
      }
      relateCustomer(url);
    };
    //关联客户
    const relateCustomer = async (url) => {
      try {
        const json = await url;
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return;
        }
        Message.success(t('关联成功'));
        data.visible = false;
        ctx.emit('cb'); //刷新客户列表
      } catch (e) {
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    // 查询客户信息
    const getCustomerQcc = async () => {
      data.loading = true;
      const params = {
        pageSize: data.pageSize,
        page: data.page,
        customerName: data.customerName,
        isNotRelated: data.isNotRelated
      };
      try {
        const json = await opportunityService.relatedCustomer(params);
        data.loading = false;
        if (!json.error) {
          console.log(json);
          if (json.result?.records) {
            data.list = json.result?.records;
          } else {
            data.list = [];
          }
          data.total = json.result?.total;
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        console.log(e);
        data.loading = false;
        Message.error(e.msg || e.statusText || t('操作失败'));
      }
    };
    const next = (current) => {
      data.page = current;
      getCustomerQcc();
    };
    //关闭
    const correlationClose = () => {
      data.page = 1;
      data.visible = false;
    };
    //创建客户
    const createdCustom = () => {
      ctx.emit('addCustom');
      data.visible = false;
    };
    //打开弹窗
    const correlationOpen = async (params) => {
      data.list = [];
      data.page = 1;
      data.type = params.type;
      data.customerName = params.customerName;
      data.isNotRelated = params?.isNotRelated;

      await getCustomerQcc();
      data.visible = true;
    };
    return {
      correlationClose,
      correlationOpen,
      next,
      getCustomerQcc,
      selectCustomer,
      imgSvg,
      searchObj,
      getSerachData,
      createdCustom,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-band-customer.less';
</style>
<style lang="less">
.information-modal {
  .arco-modal-body {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    padding: 0;
  }

  .arco-modal-header {
    justify-content: end;
    height: 50px;
  }

  .arco-modal-title {
    justify-content: flex-start;
  }

  .arco-modal-footer {
    border-top: none;
  }

  .arco-input-wrapper {
    width: 290px;
  }
}
</style>
